/**
 * wim-third-party-loader
 * Difiere la carga de scripts de terceros no críticos (GTM, píxel de
 * remarketing) fuera del critical path para mejorar TBT/bootup.
 *
 * Cada loader registrado en `window.wimDeferredScripts` se ejecuta una sola
 * vez, en cuanto ocurra lo primero entre: una interacción del usuario, el
 * navegador en idle tras el evento `load`, o un timeout de seguridad. El array
 * `window.dataLayer` se define síncrono en el <head>, por lo que los eventos
 * encolados antes de cargar GTM se procesan al inicializarlo (medición intacta).
 */
(function () {
  // Límite máximo para disparar sin interacción. Acota la ventana en la que un
  // rebote sin interactuar podría no cargar GTM (pageview perdido): solo se
  // pierde si el usuario abandona antes de este umbral.
  const FALLBACK_TIMEOUT = 2500;
  const INTERACTION_EVENTS = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
  let fired = false;
  let idleTimerId = 0;
  let hardTimerId = 0;

  const logError = (e) => {
    if (window.console && console.warn) console.warn('[wim-third-party-loader]', e);
  };

  const run = () => {
    if (fired) return;
    fired = true;
    cleanup();
    const queue = Array.isArray(window.wimDeferredScripts) ? window.wimDeferredScripts : [];
    queue.forEach((loader) => {
      try { loader(); } catch (e) { logError(e); } // aislar el fallo de un loader del resto
    });
    // Tras el disparo, los registros tardíos se ejecutan de inmediato.
    window.wimDeferredScripts = { push: (loader) => { try { loader(); } catch (e) { logError(e); } } };
  };

  const cleanup = () => {
    INTERACTION_EVENTS.forEach((evt) => window.removeEventListener(evt, run));
    if (idleTimerId) window.clearTimeout(idleTimerId);
    if (hardTimerId) window.clearTimeout(hardTimerId);
  };

  const scheduleIdle = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: FALLBACK_TIMEOUT });
    } else {
      idleTimerId = window.setTimeout(run, FALLBACK_TIMEOUT);
    }
  };

  INTERACTION_EVENTS.forEach((evt) =>
    window.addEventListener(evt, run, { once: true, passive: true })
  );

  if (document.readyState === 'complete') {
    scheduleIdle();
  } else {
    window.addEventListener('load', scheduleIdle, { once: true });
  }

  // Fallback duro desde el arranque: garantiza el disparo aunque `load`/idle se
  // retrasen, sin depender del evento `load` (clave para rebotes sin interacción).
  hardTimerId = window.setTimeout(run, FALLBACK_TIMEOUT);
})();
